import { AnyAction } from 'redux'
import { FORM_CHANGE } from '../formActionTypes'

export interface IModifiedState {
  lastModified: Date
}

export const initialModifiedState: IModifiedState = {
  lastModified: new Date(),
}

export function modifiedReducer(
  state = initialModifiedState,
  action: AnyAction,
) {
  switch (action.type) {
    case FORM_CHANGE:
      return {
        lastModified: new Date(),
      }
    default:
      return state
  }
}
